import { Box, Typography, makeStyles, Grid, Paper } from "@material-ui/core";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyle = makeStyles((theme) => ({
  iconBox: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff",
  },
  green: {
    color: theme.palette.success.main,
  },
}));
export default function Card({ title, value, isLoading, name }) {
  const classes = useStyle();
  return (
    <Grid item xs={12} sm={6} lg={3}>
      <Paper elevation={0}>
        <Box py={2} px={3}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Box>
              <Typography
                variant="h6"
                color="textSecondary"
                style={{ textTransform: "uppercase" }}
              >
                {title}
              </Typography>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <>
                {name?
                <Typography variant="h3">{value ? value : 0.0}</Typography>:
                <Typography variant="h3">{value ? parseFloat(value).toFixed(2) : 0.0}</Typography>
              }
                </>
              )}
            </Box>
            <Box
              className={classes.iconBox}
              style={{
                background: "linear-gradient(87deg,#2dce89,#2dcecc) #2dce89",
              }}
            >
              <AccountBalanceIcon />
            </Box>
          </Box>
          <Box display="flex" className={classes.green}>
            <Typography variant="body2" color="textPrimary">
              consectetur adipisicing elit
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
}
